//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export class PermissionConstantsAllowForTarget
{
	public static Assignments: string = `allow_for_target.assignments`;
	public static ChangeCompany: string = `allow_for_target.change_company`;
}
